/* eslint-disable */
import React from "react";
import ChatComponent from "../../components/ChatComponent/ChatComponent";
import PaperComponent from "../../components/PaperComponent/PaperComponent";

export default function ChatPage() {
  return <PaperComponent children={<ChatComponent/>} />;
}
